export default {
  strict: true,
  namespaced: true,
  state: {
    driverTNC: {
      stagingType: 'all'
    },
    driverTCP: {
      stagingType: 'all'
    },
    stagingLists: []
  },
  mutations: {
    setDriverTNCstagingType(state, value) { state.driverTNC.stagingType = value },
    setDriverTCPstagingType(state, value) { state.driverTCP.stagingType = value },
    setDriverStagingLists(state, value) { state.stagingLists = value }
  }
};



// WEBPACK FOOTER //
// ./src/store/laxit/driver-tnc-tcp-staging.js